import {useEffect, useState} from "react";
import {useForm} from "antd/es/form/Form";
import {account} from "../lib/appwrite";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {useLocalStorage} from "./localStorage-controller";
import {useAuth} from "../context/authContext";
import {Modal} from "antd";
import {LogoutOutlined} from "@ant-design/icons";
import "../components/modals/logout-confirm/style.less";

export const useAuthController = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [authForm] = useForm()
  const {setAuthUserData, clearAuthUserData} = useLocalStorage()
  const {toggleAuthFlag} = useAuth()

  useEffect(() => {
    if (!isModalOpen) {
      authForm.resetFields()
    }
  }, [])

  const toggleModalVisible = () => {
    setIsModalOpen(!isModalOpen)
  }

  const loginHandler = async ({email, password}: { email: string; password: string }) => {
    setIsLoading(true);
    try {

      // 1. Створити нову сесію
      await account.createEmailPasswordSession(email, password);

      // 3. Отримати користувача
      const user = await account.get();
      setAuthUserData({id: user.$id, name: user.name, email: user.email, labels: user.labels ?? []});
      toggleModalVisible();
      openSuccessNotification("Авторизація успішна");
      toggleAuthFlag();
    } catch (error) {
      showErrorNotification({
        message: "Помилка авторизації!",
        description: JSON.stringify(error),
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmLogout = () => {
    const {confirm} = Modal;

    confirm(
      {
        width: 440,
        centered: true,
        className: "logout-confirm-modal",
        icon: <LogoutOutlined/>,
        title: "Вийти з облікового запису?",
        content: "Для керування заявками та доступу до робочих розділів потрібно буде ввійти знову.",
        okText: "Так, вийти",
        okButtonProps: {danger: false},
        cancelText: "Залишитися",
        onOk: async () => {
          await logoutHandler()
        },
      });

  }

  const logoutHandler = async () => {
    setIsLoading(true)
    try {
      await account.deleteSessions()
      clearAuthUserData()
      openSuccessNotification("Успішно!")
      toggleAuthFlag()
    } catch (error) {
      console.error(error)
    } finally {
      {
        setIsLoading(false)
      }
    }
  }


  return {isModalOpen, toggleModalVisible, authForm, loginHandler, isLoading, logoutHandler, confirmLogout}
}
